<template>
  <!--  <div class="d-flex fill-height">-->
  <div v-if="resolvedDutyActivities" class="d-flex flex-column align-start" style="overflow-y: hidden">
    <div class="full-width flex-grow-1" style="overflow-y: hidden; display: flex; flex-direction: column">
      <div class="text-h6">Dienst {{ duty && duty.dutyname }}{{ resolvedUserFromVbzNr ? ' / ' + resolvedUserFromVbzNr : '' }}</div>

      <table class="table text-left" style="width: 700px">
        <tr>
          <th style="width: 80px">Linie</th>
          <th style="width: 80px">Kurs</th>
          <th style="width: 130px">von</th>
          <th style="width: 130px">bis</th>
          <th style="width: auto">Bezeichnung</th>
        </tr>
      </table>
      <div style="overflow-y: scroll">
        <table class="table text-left" style="width: 700px">
          <tr>
            <th style="width: 80px"></th>
            <th style="width: 80px"></th>
            <th style="width: 130px"></th>
            <th style="width: 130px"></th>
            <th style="width: auto"></th>
          </tr>
          <tbody class="text-left">
            <tr v-if="resolvedDutyActivities.length === 0">
              <td colspan="4" class="caption">Keine Dienstdaten gefunden</td>
            </tr>
            <tr v-for="(da, ind) in resolvedDutyActivities" :key="ind">
              <td class="text-left">
                <div v-if="da.line">{{ da.line }}</div>
              </td>
              <td>
                <div v-if="da.course">{{ da.course }}</div>
              </td>
              <td>
                <v-btn outlined text :style="getColor(da._startNo)" @click="saveStart(da, ind)">{{ da.from }} {{ da.fromLocation }} </v-btn>
              </td>

              <td>
                <v-btn outlined text :style="getColor(da._endNo)" @click="saveEnd(da, ind)">{{ da.to }} {{ da.toLocation }} </v-btn>
              </td>

              <td class="px-3">
                <v-btn outlined text v-if="isUmlaufstueck(da)" @click="selectUmlauf(da)"
                  >{{ da.longName }} {{ da.activityLongname }}({{ da.activityShortname }} )</v-btn
                >
                <div v-else>{{ da.activityLongname }}</div>
              </td>
              <td>{{ da.fzgNummer || da.daFzgNummer }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="warning--text px-2" :class="selectionAlert ? 'full-width' : ''" style="height: 30px">
      {{ selectionAlert ? selectionWarningMessage : '' }}
    </div>
    <div class="text--subtitle-1 py-2">Selektion, welche ins Formular übertragen wird</div>
    <div class="full-width d-flex align-start pa-2" style="height: 110px; border: 1px solid grey; border-radius: 6px">
      <duty-parts-selection-result :selectedDutyParts="selectedDutyParts"></duty-parts-selection-result>
    </div>
    <!--    <div class="d-flex flex-column col-12 col-sm-6 ml-4 scrollContainer border-green">-->

    <v-card-actions class="full-width justify-end">
      <v-btn @click="$emit('cancel')">abbrechen</v-btn>
      <v-btn :disabled="selectedDutyParts.length === 0" @click="reset">zurücksetzen</v-btn>
      <v-btn :disabled="selectedDutyParts.length === 0" color="primary" @click="save">übernehmen</v-btn>
    </v-card-actions>
    <!--    </div>-->
  </div>
</template>
<script>
import dateUtils from '@/common/dateUtils';
import { mapState } from 'vuex';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import DutyPartsSelectionResult from '@/modules/customerVbzWorksheet/components/DutyPartsSelectionResult.vue';

export default {
  name: 'DutyPartsSelection',
  components: { DutyPartsSelectionResult },
  mixins: [wsMixin],
  props: {
    selectedDuty: Object,
    dutyName: String,
    vbzNr: String,
    day: Date,
    duty: Object,

    dutyActivities: Array,
    numberOfUsedItems: { type: Number, default: 1 }, // From a normal edit form, the user can select only one part
  },

  data() {
    return {
      colorPalette: ['#40930b', '#4c9bc2', '#e861dc', '#3e5ca9'],
      selectionAlert: false,
      selectionWarningMessage: '',
      resolvedDutyActivities: this.dutyActivities,
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['users', 'dutyStopsById']),
    resolvedUserFromVbzNr() {
        const employeenr=this.duty && this.duty.employeenr;
        if (!employeenr) return 'nicht zugewiesen';
        let user = this.userByEmployeeNr[employeenr];
        if (user) return this.mx_formatUser(user);
        return employeenr?`zugewiesen an unbekannte VBZ Nr. ${employeenr}`:'nicht zugewiesen';

      // let companyNr = this.duty && this.duty.employeenr ? this.mx_resolveEmployeeNrToCompanyNr(this.duty.employeenr) : null;
      // let vbzNr = companyNr;
      //
      // return vbzNr ? this.mx_formatUserFromCompanyNr(vbzNr) : `nicht zugewiesen`;
    },
    // calculates an array of selected parts, whereas the from / to are gathered within one item
    selectedDutyParts() {
      let selection = [];
      let dutyPart = null;
      this.resolvedDutyActivities.forEach((da) => {
        if (da._start && !dutyPart) {
          dutyPart = { ...da, dutyPartName: `${da.dutyname}/${da._startNo + 1}` };
        }
        if (da._end) {
          if (!dutyPart) dutyPart = {}; // however it is wrong to end first

          // try to fix missing line/course
          if (!dutyPart.line) dutyPart.line = da.line;
          if (!dutyPart.course) dutyPart.course = da.course;

          dutyPart.to = da.to;
          dutyPart.toLocation = da.toLocation;

          selection.push(dutyPart);
          dutyPart = null;
        }
        // try to fix missing line/course
        if (dutyPart && !dutyPart.line) dutyPart.line = da.line;
        if (dutyPart && !dutyPart.course) dutyPart.course = da.course;
      });
      return selection;
    },
  },
  methods: {
    isUmlaufstueck(da) {
      return da.activityShortname && (da.activityShortname.includes('Umlaufstück') || da.activityShortname.includes('Umlstk'));
    },
    reset() {
      this.resolvedDutyActivities.forEach((da) => {
        da._start = false;
        da._end = false;
        delete da._startNo;
        delete da._endNo;
      });
    },
    save() {
      let dutySelection = { duty: this.selectedDuty, resolvedDutyActivities: this.resolvedDutyActivities, selectedDutyParts: this.selectedDutyParts };
      this.$emit('save', dutySelection);
    },

    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight);
    },
    getLocation(locationId) {
      let location = this.dutyStopsById[locationId];
      return location && location.shortname ? location.shortname.substring(0, 4) : null;
    },
    getColor(index) {
      return index !== null ? { background: this.colorPalette[index] } : null;
    },

    saveStart(da) {
      let { startCounts } = this.determineExistingStartEndMarkers();
      if (startCounts < 2 || da._start) {
        da._start = !da._start;
        this.determineDutyPartNumbers();
      } else {
        this.selectionAlert = true;
        this.selectionWarningMessage = 'Bereits 2 Dienstbeginne markiert';
        setTimeout(() => (this.selectionAlert = false), 2000);
      }
    },

    saveEnd(da) {
      let {  endCounts } = this.determineExistingStartEndMarkers();
      if (endCounts < 2 || da._end) {
        da._end = !da._end;
        this.determineDutyPartNumbers();
      } else {
        this.selectionAlert = true;
        this.selectionWarningMessage = 'Bereits 2 Dienstenden markiert';
        setTimeout(() => (this.selectionAlert = false), 2000);
      }
    },
    selectUmlauf(da) {
      da._start = !da._start;
      da._end = !da._end;
      this.determineDutyPartNumbers();
    },

    determineExistingStartEndMarkers() {
      let startCounts = 0,
        endCounts = 0;
      this.resolvedDutyActivities.forEach((da) => {
        if (da._start) startCounts++;
        if (da._end) endCounts++;
      });
      return { startCounts, endCounts };
    },
    determineDutyPartNumbers() {
      // set duty part numbers
      let start = 0;
      let end = 0;
      this.resolvedDutyActivities.forEach((da) => {
        if (da._start) {
          if (start > 1) {
            da._start = false;
            delete da._startNo;
          } else {
            da._startNo = start++;
          }
        } else {
          delete da._startNo;
        }
        if (da._end) {
          if (end > 1) {
            da._end = false;
            delete da._endNo;
          } else {
            da._endNo = end++;
          }
        } else {
          delete da._endNo;
        }
      });
    },
  },
  watch: {
    dutyActivities(newValue) {
      this.resolvedDutyActivities = newValue;
    },
  },
};
</script>
